import React, { useState, useContext, useEffect } from "react";
import { TodoContext } from "../context";
import Modal from "./Modal";
import TodoForm from "./TodoForm";
import { calendarItems } from "../constants";
import firebase from "../firebase";
import moment from "moment";
import randomcolor from "randomcolor";

export default function AddNewTodo() {
  //CONTEXT
  // const { selectedProject } = useContext(TodoContext);
  // projects bilgisi context'den dolayısıyla firebase'den geleceğinden
  const { projects, selectedProject } = useContext(TodoContext);
  // STATE
  const [showModal, setShowModal] = useState(false);
  const [text, setText] = useState("");
  const [day, setDay] = useState(new Date());
  const [time, setTime] = useState(new Date());
  // const [todoProject, setTodoProject] = useState();
  const [todoProject, setTodoProject] = useState(selectedProject);

  // projects bilgisi artık context'den dolayısıyla firebaseden olacağından...
  // const projects = [
  //   { id: 1, name: "personal", numOfTodos: 0 },
  //   { id: 2, name: "work", numOfTodos: 1 },
  //   { id: 3, name: "other", numOfTodos: 2 },
  // ];

  function handleSubmit(e) {
    e.preventDefault(); // form,sayfa refresh etmesin
    if (text && !calendarItems.includes(todoProject)) {
      firebase
        .firestore()
        .collection("todos")
        .add({
          text: text,
          date: moment(day).format("MM/DD/YYYY"),
          day: moment(day).format("d"),
          time: moment(time).format("hh:mm A"),
          projectName: todoProject,
          checked: false,
          color: randomcolor({ luminosity: "dark" }),
        });
      //form alanını boşaltalım
      setShowModal(false);
      setText("");
      setTime(new Date());
      setDay(new Date());
    }
  }
  // setTodoProject(selectedProject);
  // bununla loop'a girer

  useEffect(() => {
    setTodoProject(selectedProject);
  }, [selectedProject]);

  return (
    <div className="AddNewTodo">
      <div className="btn">
        <button onClick={() => setShowModal(true)}>+ new todo</button>
      </div>
      <Modal showModal={showModal} setShowModal={setShowModal}>
        <TodoForm
          handleSubmit={handleSubmit}
          heading="Add new to do!"
          text={text}
          setText={setText}
          day={day}
          setDay={setDay}
          time={time}
          setTime={setTime}
          projects={projects}
          todoProject={todoProject}
          setTodoProject={setTodoProject}
          showButtons={true}
          setShowModal={setShowModal}
        />
      </Modal>
    </div>
  );
}
